export function generateLabelDateArray(from, to, dateArray, interval, eow) {
    let labelDateArray = [];

    interval = Number(interval);

    // 실 데이터와 상관 없이 from ~ to, interval을 기준으로 labelDateArray생성
    if(interval > 0) {
        
        let dateList = [];
        let currentDate = new Date(from);
        let lastDate = new Date(to);


        //interval 이 있어서 day 가 null로 들어올때 초기화
        if(eow === null){
            eow = currentDate.getDay();
        }else
        {
            eow = Number(eow);
        }


        //시작날의 getDate()가 설정 요일의 getDate()보다 작을때
        if(currentDate.getDay() > eow ){

            // 시작 날짜의 요일이 설정한 요일보다 클 경우, 설정한 요일로부터 다음 주의 해당 요일까지의 날짜를 구하여 시작 날짜로 설정
            let daysUntilNextDay = 7 - (currentDate.getDay() - eow); // 다음 주의 해당 요일까지의 날짜
            currentDate.setDate(currentDate.getDate() + daysUntilNextDay);

        }else {
            //설정 요일의 getDate()가 시작날의 getDate()보다 클 때
            //수가 같을 때까지 더하면 된다.
            while (currentDate.getDay() !== eow) {
                currentDate.setDate(currentDate.getDate() + 1);
            }
        }
        

        while (currentDate <= lastDate) {
            
            dateList.push(formatingDateLabel(new Date(currentDate)));
            currentDate.setDate(currentDate.getDate() + interval);
        }

        labelDateArray = dateList;
    } else {
        // interval을 무시하고 from ~ to 를 기준으로 실 데이터만으로 labelDateArray 생성
        labelDateArray = dateArray.filter(date => {
            return (
                date >= from &&
                date <= to
            );
        });
    }

    return labelDateArray;
}

export function formatingDateLabel(dateObj) {
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
}

// Snapshot Data를 오름차순으로 정렬
export function getLastSnapshotDate(snapshotDataArray) {
    snapshotDataArray.sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
    });

    let lastSnapshotDate = snapshotDataArray[snapshotDataArray.length - 1].date;

    return lastSnapshotDate;
}

export function getHistoryGroupByStatus(historyData, lastDateObj) {
    let chatMap = new Map();

    for(let i = 0; i < historyData.length; i++) {

        if(lastDateObj != undefined) {
            if(historyData[i].updatedDate == '') {
                continue;
            }
            let tempDate = new Date(historyData[i].updatedDate);
            let updatedDateObj = new Date(tempDate.toISOString().slice(0, 10));

            if(lastDateObj.getTime() < updatedDateObj.getTime()) {
                continue;
            }
        }

        let currentChat = historyData[i];
        // {chatId}-{status}을 키값으로 이미 존재하는지 확인
        // Map안의 또 Object, Map이 있는 구조도 생각해봤으나 해싱의 느낌으로 Key값에 chatId와 status정보를 같이 가지고있는 방법으로 결정
        let key = `${currentChat.chatId}-${currentChat.status}`;

        // 존재하지 않으면 저장
        if(!chatMap.has(key)) {
            // updatedDate의 최소, 최대 값 초기화
            currentChat.minUpdatedDate = currentChat.updatedDate;
            currentChat.maxUpdatedDate = currentChat.updatedDate;
            chatMap.set(key, currentChat);
        } else {
            
            if(historyData[i].updatedDate == '') {  // updatedDate가 없다면 비교할 이유가 없음
                continue;
            }
            // 수정날짜 비교
            // 이미 저장되어 있는 chat 오브젝트 가져옴
            let chat = chatMap.get(key);
            // 최초 최소, 최대 변수들을 기존 chat 값으로 초기화
            let minUpdatedDateStr = chat.minUpdatedDate;
            let maxUpdatedDateStr = chat.maxUpdatedDate;

            // minUpdatedDate가 최초 등록일 경우
            if(minUpdatedDateStr == '') {
                minUpdatedDateStr = currentChat.updatedDate;
            } else {    // 이미 등록된 값이 있는 경우
                let minUpdatedDateObj = new Date(minUpdatedDateStr);
                let currentUpdatedDateObj = new Date(currentChat.updatedDate);

                if(currentUpdatedDateObj.getTime() < minUpdatedDateObj.getTime()) {
                    minUpdatedDateStr = currentChat.updatedDate;
                }

            }
            // manUpdatedDate가 최초 등록일 경우
            if(maxUpdatedDateStr == '') {
                maxUpdatedDateStr = currentChat.updatedDate;

                // 최신 버전이 있다면 갱신
                chat = currentChat;
            } else {    // 이미 등록된 값이 있는 경우
                let maxUpdatedDateObj = new Date(maxUpdatedDateStr);
                let currentUpdatedDateObj = new Date(currentChat.updatedDate);

                if(currentUpdatedDateObj.getTime() > maxUpdatedDateObj.getTime()) {
                    maxUpdatedDateStr = currentChat.updatedDate;

                    chat = currentChat;
                }
            }

            chat.minUpdatedDate = minUpdatedDateStr;
            chat.maxUpdatedDate = maxUpdatedDateStr;

            chatMap.set(key, chat);
        }
    }

    let returnChatHistoryArray = Array.from(chatMap.values());

    return returnChatHistoryArray;
}

/** 프로젝트의 startDate, endDate가 없을 때
 * 프로젝트의 히스토리를 기준으로 최초 Chatter 생성 시간, 마지막 Chatter Update 시간을 start, end로 구분하여 반환
 * 
 * @param {*} historyData 
 */
export function getProjectPeriodByHistory(historyData) {
    // from ~ to 구하기

    let creationDateSet = new Set();
    let actualDateSet = new Set();

    // 날짜 정보 중복 제거
    for(let data of historyData) {
        if(data.date != '') {
            creationDateSet.add(data.date);
        }
        
        if(data.actualDate != '') {
            actualDateSet.add(data.updatedDate);
        }
    }

    // 배열로 변경
    let labelDateArray = [...creationDateSet, ...actualDateSet];

    labelDateArray.sort((a, b) => new Date(a) - new Date(b));

    let start = labelDateArray[0];
    let end = labelDateArray[labelDateArray.length - 1];

    return [start, end]
}